import { generatePath } from 'react-router-dom';

import { ROUTE_HOLIDAY_SALE_LOGIN, ROUTE_HOLIDAY_SALE_BUY } from './constants';

export const getRouteHolidaySaleLogin = () => generatePath(ROUTE_HOLIDAY_SALE_LOGIN);

export const getRouteHolidaySaleSelect = () => generatePath(ROUTE_HOLIDAY_SALE_BUY);
